import {rtkQueryApi} from '~/shared/api/rtk-query-api';
import {buildFiltersParams} from '~/shared/utils/buildFiltersParams';
import {IPagination} from '../types/types';

export const accountsApi = rtkQueryApi
  .enhanceEndpoints({
    addTagTypes: ['accounts', 'templates'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      getAccounts: builder.query<IPagination, any>({
        query: ({page, pageSize, search, sort_by, sort_dir}) => {
          const params = new URLSearchParams();

          params.set('page', page);
          params.set('page_size', pageSize);
          if (search?.trim()) {
            params.set('search', search.trim());
          }
          if (sort_by) params.set('sort_by', sort_by);
          if (sort_dir) params.set('sort_dir', sort_dir);

          return {
            url: `/account?${params.toString()}`,
            method: 'GET',
          };
        },
        providesTags: ['accounts'],
        transformResponse: res => res as IPagination,
      }),
      updateComment: builder.mutation({
        query: ({account_id, comment}) => ({
          url: `account/${account_id}/comment`,
          method: 'POST',
          body: {comment},
        }),
        invalidatesTags: ['accounts'],
      }),
      createCampaign: builder.mutation({
        query: campaign => {
          return {
            url: 'campaign/create',
            method: 'POST',
            body: campaign,
          };
        },
      }),
      createMultipleCampaign: builder.mutation({
        query: multuple_template_data => {
          return {
            url: 'campaign/create/multiple',
            method: 'POST',
            body: multuple_template_data,
          };
        },
      }),
      previewMultipleCampaignBudget: builder.mutation({
        query: payload => {
          return {
            url: 'campaign/create/multiple/preview',
            method: 'POST',
            body: payload,
          };
        },
      }),
      checkDomains: builder.mutation({
        query: ({ domains }) => ({
          url: 'campaign/domain/check',
          method: 'POST',
          body: { domains },
        }),
      }),
      sync: builder.mutation({
        query: () => {
          return {
            url: 'external/retool/sync-profiles',
            method: 'POST',
          };
        },
      }),
      createAccount: builder.mutation({
        query: acc => {
          return {
            url: 'account/create',
            method: 'POST',
            body: acc,
          };
        },
      }),
      assignAccount: builder.mutation({
        query: ({account_id, user_id}) => {
          return {
            url: 'account/assign',
            method: 'POST',
            body: {account_id, user_id},
          };
        },
      }),
      getFilteredAccounts: builder.query<
        IPagination,
        {page?: number; pageSize?: number; filters?: Record<string, any>; sort_by?: string; sort_dir?: string}
      >({
        query: ({page, pageSize, search, filters, sort_by, sort_dir}: any) => {
          const params = new URLSearchParams();
          params.set('page', page);
          params.set('page_size', pageSize);
          if (search?.trim()) {
            params.set('search', search.trim());
          }
          if (sort_by) params.set('sort_by', sort_by);
          if (sort_dir) params.set('sort_dir', sort_dir);

          const filtersParams = buildFiltersParams(filters);
          filtersParams.forEach((value, key) => {
            params.append(key, value);
          });

          return {
            url: `/account?${params.toString()}`,
            method: 'GET',
          };
        },
      }),
    }),
  });

export const {
  useGetAccountsQuery,
  useLazyGetFilteredAccountsQuery,
  useUpdateCommentMutation,
  useCreateCampaignMutation,
  useCreateMultipleCampaignMutation,
  usePreviewMultipleCampaignBudgetMutation,
  useCheckDomainsMutation,
  useCreateAccountMutation,
  useSyncMutation,
  useAssignAccountMutation,
} = accountsApi;
